/*
 * @Descripttion: 文本json文件
 * @version:
 * @Author: leo.liu
 * @Date: 2021-08-29 06:52:13
 * @LastEditors: qianlishi
 * @LastEditTime: 2021-09-28 14:20:12
 */
export const widgetText = {
  code: "widget-text",
  type: "html",
  label: "文本",
  icon: "icon-Font1",
  options: {
    // 配置
    setup: [
      // {
      //   type: "el-input-text",
      //   label: "图层名称",
      //   name: "layerName",
      //   required: false,
      //   placeholder: "",
      //   value: "文本框",
      // },
      {
        type: "el-input-textarea",
        label: "文本内容",
        name: "text",
        required: false,
        placeholder: "",
        value: "文本框",
      },
      {
        type: "el-input-number",
        label: "字体大小",
        name: "fontSize",
        required: false,
        placeholder: "",
        value: "26",
      },
      {
        type: "vue-color",
        label: "字体颜色",
        name: "color",
        required: false,
        placeholder: "",
        dark: "#FFFFFF",
        value: "#2D3446",
      },
      {
        type: "el-input-number",
        label: "字体间距",
        name: "letterSpacing",
        required: false,
        placeholder: "",
        value: "0",
      },
      {
        type: "el-select",
        label: "字体边框",
        name: "fontBorder",
        required: false,
        placeholder: "",
        selectOptions: [
          { code: "0", name: "无边框" },
          { code: "1", name: "有边框" },
        ],
        value: "0",
      },
      {
        type: "vue-color",
        label: "字体背景",
        name: "background",
        required: false,
        placeholder: "",
        value: "rgba(115,170,229,.0)",
      },
      {
        type: "el-select",
        label: "文字粗细",
        name: "fontWeight",
        required: false,
        placeholder: "",
        selectOptions: [
          { code: "normal", name: "正常" },
          { code: "bold", name: "粗体" },
          { code: "bolder", name: "特粗体" },
          { code: "lighter", name: "细体" },
        ],
        value: "normal",
      },
      {
        type: "el-select",
        label: "对齐方式",
        name: "textAlign",
        required: false,
        placeholder: "",
        selectOptions: [
          { code: "center", name: "居中" },
          { code: "left", name: "左对齐" },
          { code: "right", name: "右对齐" },
        ],
        value: "center",
      },
    ],
    // 数据
    data: [
    ],

    // 坐标
    position: [
      {
        type: "el-input-number",
        label: "左边距",
        name: "left",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "上边距",
        name: "top",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "宽度",
        name: "width",
        required: false,
        placeholder: "该容器在1920px大屏中的宽度",
        value: 700,
      },
      {
        type: "el-input-number",
        label: "高度",
        name: "height",
        required: false,
        placeholder: "该容器在1080px大屏中的高度",
        value: 40,
      },
    ],
  },
};
